import { CaseStatusEnum, isDisplayableCaseStatus } from '@/citator/schema/case-status-schema'
import { kCaseStatusDefinitions } from '@/citator/utils/case-status-definitions'
import { kCaseTreatmentVisualsByStatus } from './case-treatment-visuals'
import flagSvg from '@/assets/icons/flag-short-pole.svg?raw'
import filledFlagSvg from '@/assets/icons/flag-short-pole-filled.svg?raw'
import checkSvg from '@/assets/icons/check.svg?raw'
import { svgToPngDataUrl } from './svg-to-png-data-url'

export async function formatCaselawExportHtml(sourceHtml: string, caseStatus: string | null | undefined): Promise<string> {
  let treatmentHtml = '<p>Citator treatment: Unavailable</p>'
  if (isDisplayableCaseStatus(caseStatus)) {
    const { color, filled } = kCaseTreatmentVisualsByStatus[caseStatus]
    const svg = caseStatus === CaseStatusEnum.likely_good ? checkSvg : filled ? filledFlagSvg : flagSvg
    // Pages omits SVG-only DOCX images; rasterize the app asset instead of maintaining a PNG copy.
    const icon = await svgToPngDataUrl(svg.replaceAll('currentColor', color))
    treatmentHtml = `<p><img src="${icon}" width="14" height="14" alt="" />&nbsp;&nbsp;${kCaseStatusDefinitions[caseStatus].label}</p>`
  }
  const document = new DOMParser().parseFromString(sourceHtml, 'text/html')
  // The opinion owns its visible title; independently stored metadata names can differ.
  const sourceTitle = document.body.querySelector('h1')

  if (sourceTitle) {
    sourceTitle.insertAdjacentHTML('afterend', treatmentHtml)
  } else {
    // Sources without an h1 keep their content and receive no generated header.
    document.body.insertAdjacentHTML('afterbegin', treatmentHtml)
  }
  return document.body.innerHTML
}
